import script from "./ScrollImg.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScrollImg.vue?vue&type=script&setup=true&lang=ts"

import "./ScrollImg.vue?vue&type=style&index=0&id=8e0c7420&scoped=true&lang=scss"

import exportComponent from "D:\\全部项目\\funeral-and-interment\\publicnumber\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e0c7420"]])

export default __exports__